module.exports = __webpack_public_path__ + "static/media/11_portrait.1f199e88.jpg";